export interface CatalogPourbackReason {
  PourbackReasonId: number | null;
  PourbackReasonName: string;
  Enabled: boolean;
}
export const CATALOG_POURBACK_REASON_INITIAL_VALUES: CatalogPourbackReason = {
  PourbackReasonId: null,
  PourbackReasonName: "",
  Enabled: true,
};
